const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20action%20scene%2C%20warm%20golden%20and%20dark%20crimson%20color%20palette%2C%20film%20grain%20texture%2C%20vintage%20cinema%20poster%20aesthetic%2C%20dramatic%20lighting%20with%20strong%20shadows%2C%20heroic%20silhouette%20composition%2C%20luxurious%20dark%20velvet%20background%2C%20theatrical%20poster%20design&width=800&height=1120&seq=media-poster-01&orientation=portrait',
    title: '星际征途：新纪元',
    tag: '科幻大片',
    desc: '人类文明面临终极考验，史诗级太空冒险震撼来袭',
    year: '2026',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20noir%20detective%20theme%2C%20rainy%20city%20night%20scene%2C%20warm%20amber%20street%20lights%2C%20film%20noir%20aesthetic%2C%20dramatic%20shadow%20composition%2C%20mysterious%20atmosphere%2C%20dark%20rich%20color%20palette%2C%20vintage%20cinema%20poster%20style&width=800&height=1120&seq=media-poster-02&orientation=portrait',
    title: '暗夜追踪',
    tag: '悬疑动作',
    desc: '一个警探与时间赛跑的极限追凶故事',
    year: '2026',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20romantic%20comedy%20theme%2C%20warm%20sunset%20golden%20hour%20lighting%2C%20soft%20dreamy%20aesthetic%2C%20vintage%20film%20texture%2C%20playful%20romantic%20composition%2C%20warm%20amber%20and%20rose%20tones%2C%20classic%20cinema%20poster%20design%2C%20elegant%20nostalgic%20vibe&width=800&height=1120&seq=media-poster-03&orientation=portrait',
    title: '遇见你的夏天',
    tag: '浪漫喜剧',
    desc: '一次意外的相遇，谱写最温暖的城市恋曲',
    year: '2026',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20historical%20epic%20theme%2C%20ancient%20Chinese%20warrior%20silhouette%2C%20dramatic%20battlefield%20sunset%2C%20rich%20golden%20and%20crimson%20color%20palette%2C%20film%20grain%20texture%2C%20epic%20scale%20composition%2C%20classic%20wuxia%20cinema%20poster%20style%2C%20atmospheric%20depth&width=800&height=1120&seq=media-poster-04&orientation=portrait',
    title: '风云再起',
    tag: '古装武侠',
    desc: '江湖恩怨再度点燃，侠之大者为国为民',
    year: '2026',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20animated%20adventure%20theme%2C%20fantasy%20magical%20world%2C%20warm%20golden%20glow%2C%20whimsical%20storybook%20aesthetic%2C%20rich%20amber%20and%20emerald%20tones%2C%20film%20texture%2C%20enchanting%20atmosphere%2C%20classic%20animation%20poster%20design&width=800&height=1120&seq=media-poster-05&orientation=portrait',
    title: '梦境奇缘',
    tag: '动画奇幻',
    desc: '穿越梦境世界的奇妙冒险，唤醒心中童真',
    year: '2026',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              精彩预告
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              最新上线的热门影片，即刻开启观影之旅
            </p>
          </div>
          <a
            href="#carousel"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看专题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <span className="text-xs text-background-50 bg-primary-500 px-2 py-1 rounded-md whitespace-nowrap">
                    立即观看
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-1 rounded-md bg-background-50/90 text-foreground-950 font-medium whitespace-nowrap">
                    {item.year}
                  </span>
                </div>
              </div>
              <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium mb-1.5 whitespace-nowrap">
                {item.tag}
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1 leading-snug">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}